/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentStatusEnum } from './document-status-enum';

export interface PatchedDeckStatusChangeSelfPublishFileRequest {
  type?: string;
  description?: string | null;
  status?: DocumentStatusEnum;
  rejection_reason?: string | null;
}
export namespace PatchedDeckStatusChangeSelfPublishFileRequest {}
